import { useEffect } from 'react'

const useGtmRegistrationViewed = () => {
    useEffect(() => {
        dataLayer.push({
            event: 'registration',
            step: 'form_view',
            _clear: true,
        })
    }, [])
}

export default useGtmRegistrationViewed
